import { z } from "zod";
import { UNSAFE_CHARS_FOR_SLUGS } from "~/utils/constants";

// * NB: Remember to update PrismaJson types after making changes to the schemas below

export const communityFormStepOne = z.object({
    communityName: z
        .string({
            required_error: "Community name is required",
        })
        .min(1, "Community name is required"),
    communitySlug: z
        .string({
            required_error: "Community URL is required",
        })
        .min(1, "Community URL is required")
        .max(30)
        .refine(
            (slug) =>
                !UNSAFE_CHARS_FOR_SLUGS.some((char) => slug.includes(char)),
            {
                message: "URL contains invalid characters.",
            },
        ),

    communityWebsite: z
        .string()
        .optional()
        .transform((str) => str?.trim())
        .refine(
            (url) => {
                try {
                    new URL(url?.startsWith("http") ? url : `https://${url}`);
                    return true;
                } catch {
                    return false;
                }
            },
            {
                message: "Please enter a valid URL (e.g. https://example.com)",
            },
        ),

    communityEventDescriptions: z
        .string({
            required_error: "A description is required",
        })
        .min(1, "A description is required"),
    avatarImage: z.string().nullish(),
    socialLinks: z
        .object({
            url: z.string().default(""),
        })
        .nullish()
        .array()
        .optional(),
});

const CommunityGoal = z.enum([
    "audienceActivation",
    "growth",
    "ticketingAndMonetization",
    "notSure",
]);

export const communitySizes = [
    "Up to 25k",
    "25k to 100k",
    "100k to 1M",
    "1M+",
] as const;

export type communityGoals = z.infer<typeof CommunityGoal>;
export type CommunityType = z.infer<typeof communityFormStepOne>;
